import { getCookie, setCookie } from '../utils/cookie-functions';

window.onload = () => {
  const interval = setInterval(() => {
    setGpcOneTrust();
    overrideDNS();
  }, 500);

  const isLimitTheUse = getCookie('limittheuse');
  const isDoNotSell = getCookie('donotsell');

  const setGpcOneTrust = () => {
    if (window.OneTrust) {
      const userHasGpc = navigator.globalPrivacyControl;
      if (userHasGpc) {
        window.OneTrust.UpdateConsent('Category', 'C0012:0');
        window.OneTrust.gpcEnabled = true;

        const isGpcEnabled = isLimitTheUse && isDoNotSell;
        if (!isGpcEnabled) {
          setCookie('limittheuse', true, 365);
          setCookie('donotsell', true, 365);
          window.location.reload();
        }
      }
      clearInterval(interval);
    }
  };

  const getConsentGroups = () => {
    const shopifyConsentCookie = getCookie('_tracking_consent');
    const shopifyConsentCookieJSON = JSON.parse(`${decodeURIComponent(shopifyConsentCookie)}`);
    const shopifyConsentGroups = shopifyConsentCookieJSON?.cus['onetrust.groups'];
    const optanonConsentGroups = window.OnetrustActiveGroups;
    return { shopifyConsentGroups, optanonConsentGroups };
  };

  // this function is used to prevent checkout OT modal from overriding the DNS settings.
  const overrideDNS = () => {
    if (window.OneTrust) {
      const { shopifyConsentGroups, optanonConsentGroups } = getConsentGroups();
      if (
        (isLimitTheUse || isDoNotSell) &&
        (shopifyConsentGroups?.includes('C0012:1') || optanonConsentGroups?.includes('C0012'))
      ) {
        setTimeout(() => {
          window.OneTrust.UpdateConsent('Category', 'C0012:0');
          const consentUpdateInterval = setInterval(() => {
            if (getConsentGroups().shopifyConsentGroups?.includes('C0012:0')) {
              clearInterval(consentUpdateInterval);
              window.location.reload();
            }
          }, 250);
        }, 1500);
      }
      clearInterval(interval);
    }
  };
};
